import React from 'react';
import { useEffect, useState } from 'react';
import { _$http, axiosError, closeAlert, preloader, twoDecimalPlace } from '../../utils';
import { ThreeDots, XMark } from '../../components/Icons';
import { Label } from '../../components/FormUI';
import Select from "react-select";
import api from '../../services/form.services';
import { OptionProps } from '../../interfaces/forms.interface';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';

function WorkflowThresholds() {
  const navigate = useNavigate();
  const [toggleCreateModal, setToggleCreateModal] = useState(false)
  const [currencies, setCurrencies] = useState<OptionProps[]>([]);
  const [toggleEditModal, setToggleEditModal] = useState(false)
  const [toggleConfirmationModal, setToggleConfirmationModal] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<OptionProps>({ label: "Select...", value: null, name: "currency" })
  const [formData, setFormData] = useState([])
  const [formInputs, setFormInputs] = useState({
    name: "", departmentContractValueThreshold: 0, contractValueThreshold: 0, currency: ""
  })
  const [workflowThresholdId, setWorkflowThresholdId] = useState(null)
  useEffect(() => { getWorkflowThresholds(); api.fetchCurrency().then((res) => setCurrencies(res)); }, []);

  const getWorkflowThresholds = () => {
    preloader();
    _$http('GET', 'WorkflowThresholds').then(res => {
      closeAlert();
      setFormData(res.data.data);
    })
      .catch(error => {
        axiosError(error);
      })
  };

  const handleSelect = (fieldName: string, selectedOptions: any) => {
    setFormInputs({ ...formInputs, [fieldName]: selectedOptions?.value });
    setSelectedCurrency({ label: selectedOptions?.label, value: selectedOptions?.value, name: "currency" })
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setFormInputs({ ...formInputs, [name]: value })
  }

  const handleEditFields = (item: any) => {
    let curr = currencies.find(a => a.label === item.currency) ?? { label: "Select...", value: null, name: "currency" }
    setSelectedCurrency(curr)
    setFormInputs({ ...formInputs, name: item.name, departmentContractValueThreshold: item.departmentContractValueThreshold, contractValueThreshold: item.contractValueThreshold, currency: curr?.value })
    setWorkflowThresholdId(item.id)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    preloader();
    _$http('POST', 'WorkflowThresholds', formInputs).then(res => {
      closeAlert();
      setToggleCreateModal(false)
      getWorkflowThresholds()
    })
      .catch(error => {
        axiosError(error);
      })
  };

  const handleUpdate = (e: any) => {
    e.preventDefault()

    preloader();
    _$http('PUT', 'WorkflowThresholds/' + workflowThresholdId, formInputs).then(res => {
      closeAlert();
      setToggleEditModal(false)
      setWorkflowThresholdId(null)
      getWorkflowThresholds()
    })
      .catch(error => {
        axiosError(error);
      })
  };

  const handleDelete = () => {
    preloader();
    setToggleConfirmationModal(false)
    _$http('DELETE', 'WorkflowThresholds/' + workflowThresholdId).then(res => {
      closeAlert();
      setWorkflowThresholdId(null)
      const message = res.data.message
      console.log(message)
      getWorkflowThresholds()
    })
      .catch(error => {
        axiosError(error);
      })
  };

  return (
    <div className='bg-white w-full shadow-sm rounded-lg py-6'>
    <div className='flex justify-start mb-1 gap-5'>
      <span onClick={() => navigate(-1)} className="mb-2 flex gap-2 mt-1 cursor-pointer text-red-500">
        <FaArrowLeftLong />
        <span className='text-sm font-bold'>Go Back</span>
      </span>
    </div>
      <div className='flex justify-between px-6'>
        {/* <input type="text" name='search' className="border px-3 py-2 text-sm mr-1" placeholder="Search Workflow Thresholds" /> */}
        <button onClick={() => setToggleCreateModal(true)} className='red-button rounded px-4 py-2 text-sm'>Create Workflow Threshold</button>
      </div>

      <div className="relative overflow-x-auto py-4" style={{ minHeight: "600px" }}>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 notdark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 notdark:bg-gray-700 notdark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                SN
              </th>
              <th scope="col" className="px-6 py-3">
                Name
              </th>
              <th scope="col" className="px-6 py-3">
                Form Threshold
              </th>
              <th scope="col" className="px-6 py-3">
                Department Threshold
              </th>
              <th scope="col" className="px-6 py-3">
                Currency
              </th>
              <th scope="col" className="px-6 py-3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {
              formData.map((item: any, index: number) => {
                return (
                  <tr key={index} className="bg-white border-b notdark:bg-gray-800 notdark:border-gray-700">
                    <th scope="row" className="px-6 py-4">
                      {index + 1}
                    </th>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap notdark:text-white">
                      {item.name}
                    </th>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap notdark:text-white">
                      {twoDecimalPlace(item.contractValueThreshold)}
                    </th>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap notdark:text-white">
                      {twoDecimalPlace(item.departmentContractValueThreshold)}
                    </th>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap notdark:text-white">
                      {item.currency}
                    </th>
                    <td className="px-6 py-4">
                      <div className="dropdown">
                        <button title='More Options' className='text-blue-600 dropbtn'>
                          <ThreeDots />
                        </button>
                        <div className="dropdown-content" style={{ left: "0" }}>
                          <button onClick={() => { setToggleEditModal(true); handleEditFields(item) }}>Edit Workflow Threshold</button>
                          <button onClick={() => { setToggleConfirmationModal(true); setWorkflowThresholdId(item.id) }}>Delete Workflow Threshold</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      {
        toggleCreateModal &&
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: 'rgb(0 0 0 / 52%)' }}>
          <div className="modal-container bg-white mx-auto rounded shadow-lg z-50 overflow-y-auto p-4">
            <div className='flex justify-between'>
              <h2 className="text-lg">Create Workflow Threshold</h2>
              <button onClick={() => setToggleCreateModal(false)} className="ml-6 p-1" title='Close Modal'><XMark /></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-content my-4">
                <label htmlFor="" className="block mb-2 text-sm font-medium text-gray-900 notdark:text-white">WorkflowThreshold</label>

                <div>
                  <Label title="Name" required />
                  <input onChange={handleInputChange} type="text" name='name' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Contract Value Threshold" required />
                  <input onChange={handleInputChange} type="text" name='contractValueThreshold' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Department Contract Value Threshold" required />
                  <input onChange={handleInputChange} type="text" name='departmentContractValueThreshold' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Currency" required />
                  <Select
                    id="po_currency"
                    value={selectedCurrency}
                    options={currencies}
                    isMulti={false}
                    isSearchable={false}
                    onChange={(e) => handleSelect("currency", e)}
                    className="font-normal"
                    placeholder="Select..."
                    required
                  />
                </div>
              </div>

              <div className='modal-footer flex justify-end'>
                <button type="submit" className="text-white rounded bg-blue-900 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2.5 mb-2 notdark:bg-blue-600 notdark:hover:bg-blue-700 focus:outline-none notdark:focus:ring-blue-800">Submit</button>
              </div>
            </form>
          </div>
        </div>
      }
      {
        toggleEditModal &&
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: 'rgb(0 0 0 / 52%)' }}>
          <div className="modal-container bg-white mx-auto rounded shadow-lg z-50 overflow-y-auto p-4">
            <div className='flex justify-between'>
              <h2 className="text-lg">Edit Workflow Threshold</h2>
              <button onClick={() => setToggleEditModal(false)} className="ml-6 p-1" title='Close Modal'><XMark /></button>
            </div>

            <form onSubmit={handleUpdate}>
              <div className="modal-content my-4">
                <label htmlFor="" className="block mb-2 text-sm font-medium text-gray-900 notdark:text-white">WorkflowThreshold</label>

                <div>
                  <Label title="Name" required />
                  <input onChange={handleInputChange} value={formInputs.name} type="text" name='name' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Contract Value Threshold" required />
                  <input onChange={handleInputChange} value={formInputs.contractValueThreshold} type="text" name='contractValueThreshold' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Department Contract Value Threshold" required />
                  <input onChange={handleInputChange} value={formInputs.departmentContractValueThreshold} type="text" name='departmentContractValueThreshold' required style={{ minWidth: "300px" }} className="w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-800 focus:border-blue-800 p-2.5 notdark:bg-gray-700 notdark:border-gray-600 notdark:placeholder-gray-400 notdark:text-white notdark:focus:ring-blue-500 notdark:focus:border-blue-500" />
                </div>

                <div>
                  <Label title="Currency" required />
                  <Select
                    id="po_currency"
                    value={selectedCurrency}
                    options={currencies}
                    isMulti={false}
                    isSearchable={false}
                    onChange={(e) => handleSelect("currency", e)}
                    className="font-normal"
                    placeholder="Select..."
                    required
                  />
                </div>
              </div>

              <div className='modal-footer flex justify-end'>
                <button type="submit" className="text-white rounded bg-blue-900 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2.5 mb-2 notdark:bg-blue-600 notdark:hover:bg-blue-700 focus:outline-none notdark:focus:ring-blue-800">Update</button>
              </div>
            </form>
          </div>
        </div>
      }
      {
        toggleConfirmationModal &&
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: 'rgb(0 0 0 / 52%)' }}>
          <div className="modal-container bg-white mx-auto rounded shadow-lg z-50 overflow-y-auto p-4">
            <div className='flex justify-between'>
              <h2 className="text-md">Are you sure you want to delete this workflow threshold? This cannot be reversed and may impact the system performance.</h2>
              <button onClick={() => setToggleConfirmationModal(false)} className="ml-6 p-1" title='Close Modal'><XMark /></button>
            </div>

            <div className="modal-content text-left px-6 flex justify-center gap-2 mt-4">
              <button onClick={() => setToggleConfirmationModal(false)} type="button" className="rounded text-black bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium text-sm px-5 py-2.5 me-2 mb-2 notdark:bg-gray-800 notdark:hover:bg-gray-700 notdark:focus:ring-gray-700 notdark:border-gray-700">Cancel</button>
              <button onClick={() => handleDelete()} type="button" className="rounded text-white bg-blue-900 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2.5 me-2 mb-2 notdark:bg-blue-600 notdark:hover:bg-blue-700 focus:outline-none notdark:focus:ring-blue-800">Yes</button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default WorkflowThresholds;
